import { CDP_TOTAL_UNITS } from "./cdp-total-units";

const cdpTotalsRowFormula = {
    UNITS: CDP_TOTAL_UNITS,
    AVERAGE_UNITS: undefined,
    STORE_WITH_UNITS: undefined,
    TOTAL_COST: undefined,
    TOTAL_RETAIL: undefined,
    PLAN_ROWS: undefined,
    IMU_PERCENTAGE: undefined,
    AUR: undefined,
    UNIT_ROW_PERCENTAGE_PLAN: () => undefined,
    ROW_PERCENTAGE_PLAN: () => undefined,
    UNIT_DOOR_PERCENTAGE_PLAN: undefined,
    DOOR_PERCENTAGE_PLAN: undefined,
    BREADTH_PERCENTAGE_PLAN: () => undefined,
};

export const getCDPTotalsRowValue = ({ factoryOptions, getterParams }) => {
    const { metric } = factoryOptions;
    const formula = cdpTotalsRowFormula[metric.kind];
    const totalsValue = formula({ factoryOptions, getterParams });
    return totalsValue;
};
